function changeSVGColor(color) {
  var heartIcon = document.getElementById("wishlist-heart-icon");
  var pathElement = heartIcon.querySelector("path");
  pathElement.setAttribute("fill", color);
}

function isProductInWishlist(shopId, productId) {
  var storageKey = "liv-wishlist-product-" + shopId;
  var tempArray = JSON.parse(localStorage.getItem(storageKey)) || [];

  for (var i = 0; i < tempArray.length; i++) {
    if (tempArray[i].id === productId) {
      changeSVGColor("red");
      break;
    }
  }
}

// No sanitization function is needed, productTitle will be accepted as-is

function addProductToWishlist(
  shopId,
  productId,
  productURL,
  productVendor,
  productTitle,
  productPrice,
  featured_picture
) {
  // No need to sanitize, accept productTitle with all characters
  var product = {
    id: productId,
    URL: productURL,
    vendor: productVendor,
    title: productTitle, // Accept the title with all characters
    price: productPrice,
    picture_url: featured_picture,
  };

  var storageKey = "liv-wishlist-product-" + shopId;
  var tempArray = JSON.parse(localStorage.getItem(storageKey)) || [];

  var isProductInWishlist = tempArray.some(function (item, index) {
    if (item.id === productId) {
      tempArray.splice(index, 1);
      changeSVGColor("white");
      localStorage.setItem(storageKey, JSON.stringify(tempArray));
      return true;
    }
    return false;
  });

  if (!isProductInWishlist) {
    tempArray.push(product);
    localStorage.setItem(storageKey, JSON.stringify(tempArray));
    changeSVGColor("red");
  }
  console.log('activated');
}
